import * as React from "react";
import {useState} from "react";
import cx from "classnames";
import TemplateString from "./TemplateString";
import Cross from "../../assets/svg/tariffs/cross.svg";
import * as styles from "./faq.module.css";

const Faq = ({items}) => {
    const [openedId, setOpenedId] = useState(items?.length > 0 ? items[0].id : null);

    if (!items || items.length === 0) {
        return null;
    }

    return (
        <div>
            {items.map((item) => (
                <div key={item.id} className={cx(styles.faq__item, {[styles.faq__item_active]: item.id === openedId})}>
                    <h3 className={styles.faq__question}>
                        <TemplateString template={item.question} />
                    </h3>
                    <p className={styles.faq__answer}>
                        <TemplateString template={item.answer} />
                    </p>
                    <button
                        type="button"
                        onClick={() => setOpenedId(item.id)}
                        className={styles.faq__button}
                        aria-label={item.id === openedId ? "Закрыть ответ" : "Открыть ответ"}
                    />
                    <Cross className={styles.faq__cross} />
                </div>
            ))}
        </div>
    );
};

export default Faq;
